// Services.jsx
import React, {useEffect} from 'react';
import './Services.css';
import Header from '../components/Header';
import Dashboard from '../components/Dashboard';
import Footer from '../components/Footer';
import service from "../assets/img/imagefile/imagefile/roadmap.png"
import icon1 from '../assets/img/services_img/services_img/icon1.png';
import icon2 from '../assets/img/services_img/services_img/icon2.png';
import icon3 from '../assets/img/services_img/services_img/icon3.png';
import icon4 from '../assets/img/services_img/services_img/icon4.png';
import icon5 from '../assets/img/services_img/services_img/icon5.png';
import icon6 from '../assets/img/services_img/services_img/icon6.png';
import icon7 from '../assets/img/services_img/services_img/icon7.png';
import icon8 from '../assets/img/services_img/services_img/icon8.png';
import icon9 from '../assets/img/services_img/services_img/icon9.png';

import AOS from 'aos';
import 'aos/dist/aos.css';
import plusicon from '../assets/img/product_img/plusicon.png';
import { Link } from "react-router-dom";
import WhatsappButton from '../components/WhatsappButton';


const servicesData = [
  { 
    icon:icon1,
    title: 'Turn-Key Project',
    alt:'trampoline company',
    description:
      'We take care of every aspect of your project, from initial planning to final implementation, providing a fully functional and operational entertainment venue.',
  },
  {
    icon:icon2,
    title: 'Custom Made Design & Engineering',
    alt:'playground equipment company',
    description:
      'Our engineering, design, and art departments are second to none. They will advise you about the specific requirements of location and the facility, as well as design and space utilization. Let us create the right project to suit your needs.',
  },
  {
    icon:icon3,
    title: 'Top-Quality Materials',
    alt:'soft play installation',
    description:
      'To guarantee safety performance, the materials used are top-quality, certified, non-toxic, very durable, and in line with the industry standards.',
  },
  {
    icon:icon4,
    title: 'In-House Production',
    alt:'indoor commercial playground',
    description:
      'We produce the components in-house to guarantee consistent quality, great customer service, shorter delivery time for complete projects and spare parts, with an optimized price for the client.',
  },
  {
    icon: icon5,
    title: "Quality Control",
    alt:'kids playground',
    description: (
      <>
        All GEM equipment is 100% tested in our factory to ensure safety, quicker installation, perfect component fitting,( highest quality trampoline ), and high-quality product.
      </>
    ),
  },
  {
    icon:icon6,
    title: 'All Details Included',
    alt:'indoor playground',
    description:
    <>
      Our offer includes all the details that the customer expects, meaning all primary elements of the kids playground area, the platforms, safety nets, wall protection, and also the specific details that make each project unique as colors, wall design, and themes.
      </>
  },
  {
    icon:icon7,
    title: 'On-Site Installation',
    alt:'playground equipment manufacturers',
    description:
      'Our expert team of installers are an integral part behind delivering a product. They are knowledgeable about the product being installed and have the necessary tools and equipment to complete the job efficiently and safely.',
  },
  {
    icon:icon8,
    title: 'Support & Maintenance',
    alt:'playgrounds',
    description:
      'GEM support services provide the clients with access to technical experts and resources that can help them troubleshoot problems and optimize the performance of their entertainment facility. services include technical assistance, repair services, routine inspections, cleaning, and sanitation services.',
  },
  {
    icon:icon9,
    title: 'Warranty',
    alt:'playground equipment manufacturers',
    description:
      'We offer a warranty to provide our customers with a level of protection and reassurance, knowing that the product they are purchasing is guaranteed to meet certain standards. Our warranty can vary from 1 till 5 years and cover defects in materials or workmanship, as well as malfunctions that occur during normal use.',
  },
];

const Services = () => {
   useEffect(() => {
      AOS.init();
    }, [])
  let title = (<>Elevate Your<br/> Entertainment <br/>Experience</>)
  let description = (<><h2 className="ServiceContent-dashboard">Global Entertainment Manufacturer offers state-of-the-art entertainment solutions tailored to your needs. As a leading Indoor Playground Manufacturer in Jordan, we provide comprehensive services from concept design to full-scale installation, ensuring top-notch experiences worldwide</h2>
</>)
  return (
    <div>
      <Header/>
      <Dashboard title={title} imageUrl={service} description={description}/>
    <div className="Services-container">
      <h1 className="Services-title" >Our Services</h1>
        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
      <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="icon-container">
              <img
                src={plusicon}
                alt="playground equipment manufacturers"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>
      <div className="Services-grid">
        {servicesData.map((service, index) => (
          <div key={index} className="Service-card" >
            <img 
              src={service.icon} 
              alt={service.alt} 
              className="Service-icon" 
              
            />
            <h2 className="Service-title">{service.title}</h2>
            <h4 className="Service-description">{service.description}</h4>
          </div>
        ))}
      </div>
    </div>
    <Footer/>
    </div>
  );
};

export default Services;
